export default "__VITE_ASSET__BLI5Q1yS__"